import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ClosedcaptionsFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M17.38 5H6.62C4.85999 5 3.85999 6 3.85999 7.76001V16.24C3.85999 18 4.85999 19 6.62 19H17.38C19.14 19 20.14 18 20.14 16.24V7.76001C20.14 6 19.14 5 17.38 5H17.38ZM6.63055 12C6.63055 8.68848 11.2412 8.48798 11.7197 11.4203H10.417C10.0754 10.1661 7.93274 10.0845 7.93274 12C7.93274 13.8865 10.1348 13.8642 10.4452 12.5504H11.7338C11.3526 15.431 6.63055 15.4013 6.63055 12ZM12.2168 12C12.2168 8.68848 16.8275 8.48798 17.306 11.4203H16.0033C15.6617 10.1661 13.519 10.0845 13.519 12C13.519 13.8865 15.7211 13.8642 16.0316 12.5504H17.3201C16.9389 15.431 12.2168 15.4013 12.2168 12Z"
      />
    </SvgIcon>
  );
});
